import { Icon, Text } from '@leroy-merlin-br/backyard-react'
import { AlertTriangleOutline } from '@backyard-ui/icons'

import * as S from './styled'

const SecurityWarning = () => (
  <S.Wrapper>
    <S.IconWrapper>
      <Icon as={AlertTriangleOutline} size="kilo" />
    </S.IconWrapper>
    <div>
      <Text size="kilo" color="black" isBold noMargin>
        Importante
      </Text>
      <Text size="kilo" color="n900" noMargin>
        A Leroy Merlin não realiza chamadas de vídeo, não solicita a instalação
        de aplicativos de rastreamento e não pede pagamentos adicionais via
        WhatsApp para liberação ou entrega de pedidos.
      </Text>
    </div>
  </S.Wrapper>
)

export default SecurityWarning
